import { render } from "./PokemonPicture.vue?vue&type=template&id=969b95a6&scoped=true"
import script from "./PokemonPicture.vue?vue&type=script&lang=js"
export * from "./PokemonPicture.vue?vue&type=script&lang=js"

import "./PokemonPicture.vue?vue&type=style&index=0&id=969b95a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\Documents\\programming\\vue\\vue-apuntes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-969b95a6"]])

export default __exports__